import {defineMessages} from 'react-intl';

export default defineMessages({
  VFS: {
    id: 'RoyalTicketListPanel.VFS',
    defaultMessage: 'View from section {section}',
  },
  fastDeliveryTooltip: {
    id: 'RoyalTicketListPanel.fastDeliveryTooltip',
    defaultMessage: 'Electronic tickets with fast delivery',
  },
  instantDeliveryTooltip: {
    id: 'RoyalTicketListPanel.instantDeliveryTooltip',
    defaultMessage: 'Ready within minutes of your order',
  },
});
